import { DrawerTitle } from "@mixitone/components";
import RacketIcon from "@mixitone/icons/racket.svg";
import { ApplicationView } from "@mixitone/mvc";
import TournamentMatchForm from "components/Forms/TournamentMatchForm";
import { DrawerContextLink } from "components/common/DrawerContextLink";
import { RoutedDrawer } from "components/common/RoutedDrawer";
import { injectModal } from "lib/injectParams";
import { useLocation } from "react-router-dom";

interface Props {
  id: string;
  matchId: string;
}

const EditMatchDrawer = ApplicationView<Props>(({ id, matchId }: Props) => {
  const location = useLocation();
  const matchList = location.state?.matchList;

  return (
    <RoutedDrawer>
      <DrawerTitle
        icon={<RacketIcon className="mr-2 w-[24px] fill-gray-400" />}
        contextLink={<DrawerContextLink context="tournamentMatches" params={{ id }} />}
      >
        Match
      </DrawerTitle>
      <TournamentMatchForm
        id={matchId}
        attributes={{
          tournamentId: id,
          tournament_competition_id: id,
        }}
        matchList={matchList && Array.isArray(matchList) ? matchList : []}
      />
    </RoutedDrawer>
  );
});

export default injectModal(EditMatchDrawer);
